import Button, { ButtonVariants } from '@/components/atoms/Button/Button';
import ClampedText from '@/components/molecules/ClampedText';
import { GOOGLE_TRACK_INFO, READ_STORY } from '@/lib/constants';
import { BlogPreview } from '@/types/blog';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';

export interface FeaturedBlogProps {
  blog: BlogPreview;
}

const FeaturedBlog: React.FC<FeaturedBlogProps> = ({ blog }) => {
  const router = useRouter();

  return (
    <article className="col-span-full flex flex-col-reverse l:col-span-8 l:row-span-2 l:flex-row">
      <section className="flex flex-1 flex-col gap-l p-xl lg:justify-center lg:gap-xl lg:px-[60px]">
        <ClampedText className="text-body1Light uppercase text-neutral-800 lg:hidden">
          {blog?.categories}
        </ClampedText>
        <h2 className="text-h2SemiBold text-neutral-900">{blog.title}</h2>
        <div className="line-clamp-2 text-h5Light text-neutral-800">
          {blog.excerpt}
        </div>
        {blog.date && (
          <div className="text-body1Light text-neutral-800">{blog.date}</div>
        )}
        <div className="w-full md:max-w-[128px]">
          <Button
            aria-label="Read story"
            variant={ButtonVariants.Primary}
            analyticsEvent={{
              ...GOOGLE_TRACK_INFO.blogArticlePageButton,
              pageTarget: `/news/${blog.slug}`,
            }}
            onClick={() => router.push(`/news/${blog.slug}`)}
          >
            {READ_STORY}
          </Button>
        </div>
      </section>
      <div className="relative flex h-[212px] w-full flex-col items-center justify-center md:h-64 l:h-[431px] l:flex-1">
        {!!blog?.image && (
          <Image
            src={blog.image}
            className="l:rounded-xsmall"
            fill
            style={{ objectFit: 'cover' }}
            alt="blog image"
            priority
          />
        )}
      </div>
    </article>
  );
};

export default FeaturedBlog;
